import { render, staticRenderFns } from "./user-bold.vue?vue&type=template&id=2710ae6a&"
import script from "./user-bold.vue?vue&type=script&lang=js&"
export * from "./user-bold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports